import React from 'react';
import CategoryLandingTemplate from '../../components/CategoryLandingTemplate';
import tecnalData from '../../data/tecnal';

const MovimientoPortuarioPage = () => {
  return <CategoryLandingTemplate data={tecnalData['movimiento-portuario']} />;
};

export default MovimientoPortuarioPage;
